module.exports = __webpack_public_path__ + "static/cover-overlay-584fbc229a40421b7bd2ebb6abf41437.png";